import { render, staticRenderFns } from "./dictManage.vue?vue&type=template&id=d2c54e5a"
import script from "./dictManage.vue?vue&type=script&lang=js"
export * from "./dictManage.vue?vue&type=script&lang=js"
import style0 from "./dictManage.vue?vue&type=style&index=0&id=d2c54e5a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports